/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Internal API
 * OpenAPI spec version: v1
 */

export type GetApprovalContractsFilter = typeof GetApprovalContractsFilter[keyof typeof GetApprovalContractsFilter];


export const GetApprovalContractsFilter = {
  InProgress: 'InProgress',
  All: 'All',
  ToDo: 'ToDo',
} as const;
